export default {
  custom: {
    'Competition Name': null,
    'Match Date': null,
    'Match ID': null,
    'Round Number': null,
    'Team 1': null,
    'Team 2': null,
    'Venue Name': null,
  },
  sportsTg: {
    'Competition Name': 'sectionTag',
    'Match Date': 'eventDateTime',
    'Match ID': 'reference',
    'Round Number': 'round',
    'Team 1': 'groupOneCode',
    'Team 2': 'groupTwoCode',
    'Venue Name': 'locationInfo',
  },
  playHq: {
    sectionName: 'sectionName',
    seasonName: 'seasonName',
    competitionName: 'competitionName',
    matchAt: 'matchDateTime',
    uniqueKey: 'matchId',
    roundNumber: 'roundNumber',
    team1UniqueKey: 'team1Id',
    team2UniqueKey: 'team2Id',
    team1Name: 'team1',
    team2Name: 'team2',
    locationName: 'venueName',
  },
  fixi: {
    sectionName: 'Division',
    seasonName: 'Season',
    competitionName: 'Competition',
    matchAt: 'StartTime',
    uniqueKey: 'CalendarId',
    roundNumber: 'Round',
    team1UniqueKey: 'HomeTeamId',
    team2UniqueKey: 'AwayTeamId',
    team1Name: 'HomeTeamName',
    team2Name: 'AwayTeamName',
    locationName: 'CourtName',
  },
  teammo: {
    sectionName: 'Section Name',
    seasonName: 'Season Name',
    competitionName: 'Competition Name',
    uniqueKey: 'Match ID',
    roundNumber: 'Round Number',
    matchAt: 'Match Date Time',
    team1UniqueKey: 'Team 1 ID',
    team2UniqueKey: 'Team 2 ID',
    team1Name: 'Team 1',
    team2Name: 'Team 2',
    locationName: 'Venue Name',
  },
};
